export const terminalData = [
  {
    id: 1,
    state: "Accra",
    terminal: "Accra Terminal",
    logo: require("../../assets/img/aba-terminal.png").default,
    address:
      "No 126, Main Spintex road , beside Riklyn Hotel, after MTN Office, Spintex, Accra.",
    phoneNumber: "0500055350",
    email: "accra@gigm.com",
  },
  {
    id: 2,
    state: "Kumasi",
    terminal: "Kumasi Terminal",
    logo: require("../../assets/img/umuahia-terminal.png").default,
    address:
      "GIG Mobility JAKWAPO BUILDING, OPPOSITE TO ADDAI CUTLASS,OFF KEJETIA-ASAFO ROAD.",
    // phoneNumber: "0532823880",
    email: "kumasi@gigm.com",
  },
];
